import { IssueTypeService as OvermapIssueTypeService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeService extends OvermapIssueTypeService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
